<template>
    <div>
        <manual-report-processing-card class="ma-2"/>
    </div>
</template>

<script>
	import ManualReportProcessingCard from "../components/ManualReportProcessingCard";
	export default {
		name: "ManualProcessingView",
		components: {ManualReportProcessingCard}
	}
</script>

<style scoped>

</style>
